<template>
  <div class="skill">
    <div class="row">
      <div class="col-10 clipper">
        <span class="bonus">
          <ez-modal-dice
            v-if="['Savage Worlds', 'Savage Embers'].includes(ruleset)"
            slot="underline"
            :name="item.name"
            :dice="dice()"
          >{{ diceDisplay() }}</ez-modal-dice>

          <ez-modal-dice
            v-else
            slot="underline"
            :name="item.name"
            :dice="`1d20+${skillBonus}`"
          >{{ skillBonus }}</ez-modal-dice>
        </span>
        <label class="name" :class="{ trained: isTrained }">
          {{ item.name }}
          <span class="capitalize c5">({{ attributeName }})</span>
        </label>
      </div>
      <div class="col-2 text-right" v-if="canEdit">
        <a :id="`${section}-${item._id}`" @click="showEditModal = true" class="cogs125">
          <i class="fa fa-cog"></i>
        </a>
      </div>
    </div>

    <ez-modal
      v-if="showEditModal && canEdit"
      @close="showEditModal = false"
      size="m-small"
      showX="true"
    >
      <h3>Skill</h3>

      <fifth-edition
        v-if="['5th Edition', '5e24', 'Solarian Conflict'].includes(ruleset)"
        :section="section"
        :item="item"
        :ruleset="ruleset"
        :attribute="attribute"
        :skillBonus="skillBonus"
        :passiveList="passiveList"
      ></fifth-edition>
      <savage-worlds
        v-if="['Savage Worlds', 'Savage Embers'].includes(ruleset)"
        :section="section"
        :item="item"
        :ruleset="ruleset"
        :attribute="attribute"
      ></savage-worlds>
      <pfrpg
        v-if="ruleset === 'PFRPG'"
        :section="section"
        :item="item"
        :ruleset="ruleset"
        :attribute="attribute"
        :skillBonus="skillBonus"
        :sizeModifier="sizeModifier"
        :armorClassPenalty="armorClassPenalty"
        :passiveList="passiveList"
      ></pfrpg>
      <pfrpg2
        v-if="['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(ruleset)"
        :section="section"
        :item="item"
        :ruleset="ruleset"
        :attribute="attribute"
        :skillBonus="skillBonus"
        :armorClassPenalty="armorClassPenalty"
        :passiveList="passiveList"
      ></pfrpg2>

      <clone-delete-item :section="section" :item="item" @close="showEditModal = false"></clone-delete-item>
    </ez-modal>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import CloneDeleteItem from "../shared/_CloneDeleteItem.vue";
import EzModalDice from "@/components/shared/_VueEzModalDice.vue";
import FifthEdition from "./_5thEdition.vue";
import Pfrpg from "./_Pfrpg.vue";
import Pfrpg2 from "./_Pfrpg2.vue";
import SavageWorlds from "./_SavageWorlds.vue";
import Toggle from "../shared/_Toggle.vue";

import modal from "@/mixins/vue-ez-modal";

export default {
  name: "sheet-skills-skill",
  mixins: [modal],
  components: {
    CloneDeleteItem,
    EzModalDice,
    FifthEdition,
    Pfrpg,
    Pfrpg2,
    SavageWorlds,
    Toggle,
  },
  props: [
    "section",
    "item",
    "attribute",
    "skillBonus",
    "sizeModifier",
    "armorClassPenalty",
    "passiveList",
    "charisma",
  ],
  data() {
    return {
      showEditModal: false,
    };
  },
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" }),
    ...mapState({
      ruleset: (state) => state.characters.current.ruleset,
    }),
    attributeName() {
      return this.item.attribute.substring(0, 3);
    },
    isTrained() {
      return (
        this.item.proficient || this.item.ranks || this.item.proficiency > 0
      );
    },
  },
  methods: {
    dice() {
      let dice = this.item.score == 0 ? `1d4` : `1d${this.item.score}`;
      let bonus =
        this.skillBonus > -1 ? `+${this.skillBonus}` : this.skillBonus;

      dice = bonus === "+0" ? dice : `${dice}${bonus}`;
      return dice;
    },
    diceDisplay() {
      let d = this.item.score == 0 ? this.skillBonus : `d${this.item.score}`;
      return d;
    },
  },
};
</script>
<style lang="scss">
@import "../../../../assets/_global";

.skill {
  margin: 0.15em 0;
  .name {
    // color: $gray-500;
    vertical-align: middle;
  }
  .bonus {
    // color: $gray-700;
    font-weight: 700;
    font-size: 1em;
    text-align: right;
    width: 2em;
    display: inline-block;
  }
  .clipper,
  .bonus,
  .cogs125 {
    vertical-align: middle;
  }
}
</style>
